module.exports = __webpack_public_path__ + "img/about.8f1b18c9.jpg";